import React from 'react';
import ContentHeader from '../../Components/ContentHeader/ContentHeader';
import './style.css';
import CustomToast from '../../Components/CustomToast/CustomToast';

const HistoryUi = ({ historyData, toast }) => {
    if (!historyData) return <div>No History Data Available</div>;
    return (
        <div>
            <div className="content-wrapper">
                <ContentHeader
                    title="Audit History"
                    buttonName=""
                    buttonBoolean={true}
                    pageName="History"
                    linkPath=""
                />

                <section className="content">
                    <div className="container-fluid">
                        {toast && (
                            <CustomToast
                                text={toast?.message}
                                type={toast?.type}
                            />
                        )}
                        <div className="history-main-container">
                            <div className="history-heading-container">
                                <h5 className="mb-0">Data Comparison View</h5>
                                <div className="d-flex align-items-center">
                                    <span className="info-text-color">
                                        Old Version: {JSON.parse(historyData.old_completed_dates)?.[0] || "N/A"} &nbsp;
                                    </span>
                                    <span className="info-text-color">
                                        New Version: {historyData.completedDate || "N/A"}
                                    </span>
                                </div>
                            </div>

                            <div className="row g-1 mt-2">
                                {Object.keys(historyData.history).map((key, index) => {
                                    const questionData = historyData.history[key];
                                    const { question, input_type, user_answer, history: oldHistory, sub_question} = questionData;
                                    // Handle old data
                                    const oldData = oldHistory?.[0] || {};
                                     // Function to render images
                                     const renderImages = (answers) => {
                                        return answers.map((filePath, imgIndex) => (
                                            <img
                                                key={imgIndex}
                                                src={`${process.env.REACT_APP_API_ROUTE}${filePath}`}
                                                alt={`Uploaded file ${imgIndex + 1}`}
                                                className="uploaded-image"
                                                style={{ width: '100%', display:'flex', alignItems:'center',justifyContent:'center', height: '350px', objectFit:'cover'}}
                                            />
                                        ));
                                    }

                                    return (
                                        <React.Fragment key={key}>
                                            {/* Old Data */}
                                            <div className="col-md-6">
                                                <div className="comparison-card old-data-card">
                                                    {index === 0 && <h6 className="comparison-header">Old Data</h6>}
                                                        <div className="question-card">
                                                            <div className="label-question">Question {index + 1}</div>
                                                            <div className="question">
                                                            {input_type === 'media' ? questionData?.title : Object.keys(sub_question).length > 0 ? 
                                                                question : oldData.question || "N/A"}
                                                            </div>
                                                        </div>
                                                    {!Object.keys(sub_question).length > 0 && 
                                                        <div className="answer-card">
                                                            <div className="label-question">{input_type === 'media' ? '' : "Answer"}</div>
                                                            <div className="answer-qusetion">
                                                                {/* {oldData.user_answer?.join(", ") || "N/A"} */}
                                                                {input_type === 'media' ? renderImages(oldData.user_answer || []) : oldData.user_answer?.join(", ") || "N/A"}
                                                                </div>
                                                        </div>
                                                    }

                                                    {/* Sub-questions for Old Data */}
                                                    {sub_question &&
                                                        Object.keys(sub_question).map((subKey, subIndex) => {
                                                            const subData = sub_question[subKey];
                                                            const oldSubData = subData.history?.[0] || {};
                                                            if (
                                                             Object.keys(oldSubData).length > 0
                                                            ) {
                                                                return (
                                                                    <>
                                                                        <div className='d-flex align-items-start sub-question-container mt-2'>
                                                                            <i class="fas fa-circle bullet-points-icon"></i>
                                                                            <div key={subKey} className="sub-question-card w-100 ml-2">
                                                                                <div className="question-card">
                                                                                    <div className="label-question">Sub Question {subIndex + 1}</div>
                                                                                    <div className="question">{oldSubData.question || "N/A"}</div>
                                                                                </div>
                                                                                <div className="answer-card mt-2">
                                                                                    <div className="label-question">Sub Answer</div>
                                                                                    <div className="answer-qusetion">
                                                                                        {oldSubData.user_answer?.join(", ") || "N/A"}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                );
                                                            }
                                                    })}
                                                    
                                                </div>
                                            </div>

                                            {/* New Data */}
                                            <div className="col-md-6">
                                                <div className="comparison-card new-data-card">
                                                    {index === 0 && <h6 className="comparison-header">New Data</h6>}
                                                    <div className="question-card">
                                                        <div className="label-question">Question {index + 1}</div>
                                                        <div className="question">{input_type === 'media'  ? questionData?.title : question || "N/A"}</div>
                                                    </div>
                                                    {!Object.keys(sub_question).length > 0 && 
                                                    <div className="answer-card">
                                                        {/* <div className="label-question">{input_type === 'media' ? questionData?.title : "Answer"}</div> */}
                                                        <div className="label-question">{input_type === 'media' ? '' : "Answer"}</div>
                                                        <div className="answer-qusetion">
                                                            {/* {user_answer?.join(", ") || "N/A"} */}
                                                            {input_type === 'media' ? renderImages(user_answer || []) : user_answer?.join(", ") || "N/A"}
                                                        </div>
                                                    </div>
                                                    }

                                                    {/* Sub-questions for New Data */}
                                                    {sub_question &&
                                                        Object.keys(sub_question).map((subKey, subIndex) => {
                                                            const subData = sub_question[subKey];
                                                            const oldSubData = subData.history?.[0] || {};
                                                            if (
                                                                Object.keys(oldSubData).length > 0
                                                               ) {
                                                            return (
                                                                <div className='d-flex align-items-start sub-question-container mt-2'>
                                                                        <i class="fas fa-circle bullet-points-icon"></i>
                                                                    <div key={subKey} className="sub-question-card w-100 ml-2">
                                                                        <div className="question-card">
                                                                            <div className="label-question">Sub Question {subIndex + 1}</div>
                                                                            <div className="question">{subData.question || "N/A"}</div>
                                                                        </div>
                                                                        <div className="answer-card mt-2">
                                                                            <div className="label-question">Sub Answer</div>
                                                                            <div className="answer-qusetion">
                                                                                {subData.user_answer?.join(", ") || "N/A"}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )};
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default HistoryUi
